import { Reducer } from 'redux';

import { IErrorActionData } from '../../../models/Error';
import { ConfirmRefundActions, ConfirmRefundActionTypes } from '../actions/ConfirmRefund';

export interface IConfirmRefundState {
  isSuccess: boolean;
  isProcessing: boolean;
  error?: IErrorActionData;
}

const initialConfirmRefundState: IConfirmRefundState = {
  isSuccess: false,
  isProcessing: false,
  error: undefined,
};

const ConfirmRefundReducer: Reducer<IConfirmRefundState, ConfirmRefundActions> = (
  state = initialConfirmRefundState,
  action: ConfirmRefundActions,
): IConfirmRefundState => {
  switch (action.type) {
    case ConfirmRefundActionTypes.CONFIRM_REFUND_ACTION:
      return {
        ...state,
        isProcessing: true,
        isSuccess: false,
        error: undefined,
      };

    case ConfirmRefundActionTypes.CONFIRM_REFUND_ACTION_SUCCESS:
      return {
        ...state,
        isProcessing: false,
        isSuccess: true,
        error: undefined,
      };

    case ConfirmRefundActionTypes.CONFIRM_REFUND_ACTION_FAILURE:
      return {
        ...state,
        isProcessing: false,
        isSuccess: false,
        error: {
          errorCode: action.payload.errorCode,
          errorMessage: action.payload.errorMessage,
          callBack: action.payload.callBack,
        },
      };

    case ConfirmRefundActionTypes.CONFIRM_REFUND_ACTION_RESET:
      return initialConfirmRefundState;

    default:
      return state;
  }
};

export default ConfirmRefundReducer;
